/**
 * Best Sellers carousel (desktop arrows). CSS scroll-snap does the actual
 * scrolling — this only nudges scrollLeft by one card's width on arrow
 * click and disables an arrow at either end. Mobile relies on native
 * swipe alone; the arrows are hidden there (see featured-collection.liquid).
 */
if (!customElements.get('product-carousel')) {
  customElements.define(
    'product-carousel',
    class ProductCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        if (!this.track) return;

        this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
        this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        window.addEventListener('resize', () => this.updateButtons());
        this.updateButtons();
      }

      scrollByCard(direction) {
        // Distance between two consecutive items' left edges already
        // includes the gap, so this needs no computed-style gap lookup.
        const items = this.track.querySelectorAll(':scope > *');
        if (items.length === 0) return;
        const amount =
          items.length > 1
            ? (items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left) * direction
            : items[0].getBoundingClientRect().width * direction;
        this.track.scrollBy({ left: amount, behavior: 'smooth' });
      }

      updateButtons() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const atStart = this.track.scrollLeft <= 4;
        const atEnd = this.track.scrollLeft >= maxScroll - 4;
        this.prevButton?.toggleAttribute('disabled', atStart);
        this.nextButton?.toggleAttribute('disabled', atEnd || maxScroll <= 0);
      }
    }
  );
}
